<app-idms-sub-header [headerData]="subHeaderData"></app-idms-sub-header>
<div class="container-fluid mb-4">
    <div class="row">
        <div class="col-lg-12">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
